import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { Button } from "primereact/button";
import agent from "../../../../agent";

const AvrJurTable = ({ page, pageSize, onPageChange, data, totalItems }) => {
    const legalTable = useRef();

    // Поддержка как массива, так и page-объекта с полем content
    const normalizedData = useMemo(() => {
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.content)) return data.content;
        return [];
    }, [data]);

    const totalRecords = useMemo(() => {
        if (typeof totalItems === "number") return totalItems;
        if (data && typeof data.totalElements === "number") return data.totalElements;
        return 0;
    }, [data, totalItems]);



    const numberTemplate = (field) => (row) =>
        row?.[field] !== undefined && row?.[field] !== null
            ? Number(row[field]).toLocaleString("ru-RU")
            : "";
    
    const handleDownload = (row) => {
        agent.Payments.getJurAvrPdf(row.id, row.userId).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.body], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `avr_${row.avrNum || row.id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });
    };

    const downloadTemplate = (row) => (
        <Button
            icon="pi pi-download"
            className="p-button-text p-button-sm"
            onClick={() => handleDownload(row)}
            tooltip="Скачать PDF"
            tooltipOptions={{ position: 'top' }}
        />
    );

    return (
        <div className="card">
            <DataTable
                ref={legalTable}
                value={normalizedData}
                className="p-datatable-customers"
                dataKey="id"
                rowHover
                emptyMessage="Данные не найдены"
                scrollable
            >
                <Column headerStyle={{ width: "120px" }} field="id" header="ID" sortable />
                <Column headerStyle={{ width: "160px" }} field="avrNum" header="Номер АВР" sortable />
                <Column headerStyle={{ width: "160px" }} field="bin" header="БИН" sortable />
                <Column headerStyle={{ width: "340px" }} field="companyName" header="Наименование компании" sortable />
                <Column headerStyle={{ width: "160px" }} field="startDate" header="Дата начала" sortable />
                <Column headerStyle={{ width: "160px" }} field="endDate" header="Дата конца" sortable />
                <Column headerStyle={{ width: "160px" }} field="totalAmount" header="Сумма" body={numberTemplate("totalAmount")} sortable />
                <Column headerStyle={{ width: "160px" }} field="status" header="Статус" sortable />
                <Column headerStyle={{ width: "280px" }} field="userId" header="ID пользователя" sortable />
                <Column headerStyle={{ width: "100px" }} header="Скачать" body={downloadTemplate} />
            </DataTable>
            <Paginator
                currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
                template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                first={page * pageSize}
                rows={pageSize}
                totalRecords={totalRecords}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={onPageChange}
            />
        </div>
    );
};

AvrJurTable.propTypes = {
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    // data: может быть массивом или page-объектом с { content, totalElements }
    data: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.shape({
            content: PropTypes.array,
            totalElements: PropTypes.number,
        }),
    ]).isRequired,
    totalItems: PropTypes.number,
};

export default AvrJurTable;